angular.module('rjmNg.directives').directive "createDataWareHouseView", [
  () ->
    restrict: "E"
    templateUrl: "directive.createDataWareHouseView.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$location"
      "$modal"
      "$q"
      "$rootScope"
      "$routeParams"
      "$scope"
      "$timeout"
      "app"
      "appRoute"
      "notification"
      "persistentViewsService"
      (
        $location
        $modal
        $q
        $rootScope
        $routeParams
        $scope
        $timeout
        app
        appRoute
        notification
        persistentViewsService
      ) ->

        _nameValidator = /^[a-z_1-9]*$/
        _textEditOptions =
          lineNumbers: true
          lineWrapping: true
          mode: "text/x-sql"
          readOnly: false

        _title = ''
        _viewToUpdate = null

        view = @
        view.dwvLink = appRoute('/settings/persistent-views')
        view.errorNameMessage = ''
        view.errorSqlMessage = ''
        view.editable = false
        view.loading = false
        view.new = false
        view.showForceButton = false

        view.displayDependencyResolver = false

        _init = () ->
          view.loading = true
          deffered = $q.defer()
          view.editable = app.canEditPersistentViews()

          if($routeParams.viewId?)
            persistentViewsService.get($routeParams.viewId).then((result)->
              _title = result.name
              view.displayTitle = _title
              _viewToUpdate = result
              deffered.resolve()
            ,(error) ->
              notification.error("error", "Error loading Data Warehouse View", "dwv-create", "", 5)
              deffered.reject(error)
            )
          else
            view.new = true
            _title = ''
            view.displayTitle = 'Untitled View'
            deffered.resolve()
          return deffered.promise

        _initTextField = () ->
          if(!view.new and !view.editable)
            _textEditOptions.readOnly = true
            _textEditOptions.lineNumbers = false
          view.sqlEditor = CodeMirror.fromTextArea(view.sqlTextArea, _textEditOptions)
          view.sqlEditor.on('change', () ->
            if(view.errorSqlMessage)
              $timeout(() -> view.errorSqlMessage = '')
          )
          if(_viewToUpdate)
            view.sqlEditor.replaceSelection(_viewToUpdate.select_query)
          view.loading = false

        _saveError = (error) ->
          view.loading = false
          if(error.data.name?)
            view.errorNameMessage = error.data.name.join(', ')
          if(error.data.select_query?)
            view.errorSqlMessage = error.data.select_query.join(', ')
          if(app.isSupportUserSession() and _viewToUpdate)
            view.showForceButton = true
          notification.error("error", "Error saving Data Warehouse View", "dwv-create", "", 5)

        view.cancelDelete = () ->
          view.displayDependencyResolver = false
          view.dependencies = null
          view.loading = false

        view.confirmDelete = (hasSchema = true) ->
          view.displayDependencyResolver = false
          deleteFn
          if(hasSchema)
            deleteFn = persistentViewsService.forceDropViewTable
          else
            deleteFn = persistentViewsService.deleteView

          deleteFn(_viewToUpdate).then((success)->
              view.loading = false
              notification.success("saved", "View deleted successfully!", "persistent-views", "", 5)
              $location.path(view.dwvLink)
              null
            ,(error)->
              view.loading = false
              notification.error("error", "Error deleting Data Warehouse View", "dwv-create", "", 5)
            )

        view.delete = (vw) ->
          view.loading = true
          persistentViewsService.attachSchema(vw).then((viewSchema)->
            persistentViewsService.attemptDropViewTable(vw).then((result)->
              view.dependencies = result
              view.displayDependencyResolver = true
              null
            ,(error)->
              view.loading = false
              notification.error("error", "Error deleting Data Warehouse View", "dwv-create", "", 5)
            )
            null
          , (error)->
              if(vw.status is 'pending')
                view.confirmDelete(false)
              else
                view.loading = false
                notification.error("error", "Error deleting Data Warehouse View", "dwv-create", "", 5)
          )

        view.focusTitle = () ->
          if(_title.trim() is '')
            view.displayTitle = ''

        view.save = (force) ->
          view.showForceButton = false
          if(view.sqlEditor.getValue().trim() is '')
            view.errorSqlMessage = 'SQL query can\'t be blank'
          else
            view.loading = true
            view.saving = true
            view.errorNameMessage = ''
            view.errorSqlMessage = ''
            if(!_viewToUpdate)
              if(_title.trim() is '')
                view.loading = false
                view.errorNameMessage = 'Name can\'t be blank.'
              else
                viewToSave =
                  name: _title.trim()
                  select_query: view.sqlEditor.getValue()
                persistentViewsService.save(viewToSave).then((result) ->
                    view.loading = false
                    notification.success("saved", "Saved Successfully!", "persistent-views", "", 5)
                    $location.path(view.dwvLink)
                  , _saveError
                )
            else
              if(_viewToUpdate.id?)
                tempView =
                  name: _viewToUpdate.name
                  select_query: view.sqlEditor.getValue()
                  id: _viewToUpdate.id
                  force: if force and app.isSupportUserSession() then true else false
                persistentViewsService.update(tempView).then((result) ->
                    view.loading = false
                    notification.success("saved", "Saved Successfully!", "persistent-views", "", 5)
                    $location.path(view.dwvLink)
                  , _saveError
                )

        view.showDeleteModal = () ->
          persistentViewsService.showDeleteModal(_viewToUpdate, () -> view.delete(_viewToUpdate))

        view.unfocusTitle = () ->
          if(_title.trim() is '')
            view.displayTitle = 'Untitled View'

        view.validateTitle = ($event) ->
          $timeout(()->
            if(_nameValidator.test($event.target.value))
              view.errorNameMessage = ''
            else
              view.errorNameMessage = 'View names are limited to lower case letters, numbers, and underscores (_).'
            _title = $event.target.value
            view.displayTitle = _title
          )

        $scope.$on 'insertTextIntoSQLQuery', (event, text) ->
          view.sqlEditor.replaceSelection(text)
          view.sqlEditor.focus()

        view.$postLink = () ->
          _init().then(() ->
              _initTextField()
            , (error) ->
              view.loading = false
              notification.error("error", "Error loading Data Warehouse View", "dwv-create", "", 5)
            )

        return view
    ]
    link: (scope, elem, attrs) ->
      scope.view.sqlTextArea = $(elem).find('textarea')[0]
]
